import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { MatchesEffects } from './matches-effects.service';

import { matchesReducer } from './matches.reducer';

import { ToastModule } from '../../../../libs/src/toast/toast.module';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([MatchesEffects]),
    StoreModule.forFeature('matches', matchesReducer),
    ToastModule,
  ],
  providers: [MatchesEffects],
})
export class MatchesModule {}
